import { render, staticRenderFns } from "./LearningAnalytics.vue?vue&type=template&id=fe1bb2f6&scoped=true"
import script from "./LearningAnalytics.vue?vue&type=script&lang=js"
export * from "./LearningAnalytics.vue?vue&type=script&lang=js"
import style0 from "./LearningAnalytics.vue?vue&type=style&index=0&id=fe1bb2f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe1bb2f6",
  null
  
)

export default component.exports